import ImgLazy from './components/lazy.vue'

ImgLazy.install = function(Vue) {
  Vue.component(ImgLazy.name, ImgLazy)
}

export default ImgLazy
